  document.addEventListener('DOMContentLoaded', function() {
    // Get current URL path
    var path = window.location.pathname;

    // Load widget only for English pages (no locale prefix)
    var isEnglish = !path.startsWith('/sv/') && !path.startsWith('/fi/') && !path.startsWith('/fr/');

    if (isEnglish && typeof PathClip !== 'undefined') {
      PathClip.create({
        configId: 'df7dcb55da2e0dbab7b38a36d63aad5a'
      });
    }
  });
 
  console.log("Apple")